import template from './totalaudit.html';
import controller from './totalaudit.controller';
import './totalaudit.styl';

let totalauditComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default totalauditComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/totalaudit/totalaudit.component.js